<script>
	import { LayerCake, Html } from "layercake";
	import { stack } from "d3-shape";
	import { colors, variableLabels, inOutSectionsById } from "../stores.js";
	import { formatFloat } from "../utils.js";

	import GasStorage from "../elements/GasStorage.svelte";
	import Links from "../components/Links.svelte";
	import Bar from "../elements/Bar.svelte";

	export let dataIncoming;
	export let dataOutgoing;
	export let valueKey = "value";
	export let gasStorageFilled;
	export let gasStorageMonth = "";
	export let gasStorageMax = 100;
	export let maxValue = undefined;
	export let barWidth = 40;
	export let compareValueIncoming = null;
	export let compareValueOutgoing = null;
	export let compareValueStorage = null;
	export let compareLabel = "";
	export let gasStorageValueColor = "#F00";

	const xKey = "size";
	const xDomain = [0, 100];
	const yKey = [0, 1];

	const frmtF = formatFloat(0);

	// transform the data to be able to be stacked
	let transformedDataIncoming = [];
	let transformedDataOutgoing = [];

	$: {
		transformedDataIncoming = [];
		transformedDataOutgoing = [];

		Object.entries(dataIncoming.data).forEach(([key, value]) => {
			transformedDataIncoming.push({ id: key, value: value, size: dataIncoming.size });
		});

		Object.entries(dataOutgoing.data).forEach(([key, value]) => {
			transformedDataOutgoing.push({ id: key, value: value, size: dataIncoming.size });
		});
	}

	$: yDomain = [0, maxValue];

	// stack data to get the right values for the stacked bar
	const stackData = stack().keys([valueKey]);
	let stackedDataIncoming;
	let stackedDataOutgoing;
	$: {
		stackedDataIncoming = stackData(transformedDataIncoming);
		stackedDataOutgoing = stackData(transformedDataOutgoing);
	}
</script>

<div class="first" style:border-color={$colors.incoming.main}>
	<LayerCake
		y={yKey}
		x={xKey}
		{yDomain}
		{xDomain}
		ssr={true}
		percentRange={true}
		padding={{ right: 5 }}
		data={stackedDataIncoming}
	>
		<Html>
			<Bar
				{barWidth}
				title={$inOutSectionsById.incoming.title}
				subtitle={$inOutSectionsById.incoming.subtitle}
				color={(d) => $colors.incoming[d.id]}
				direction={"incoming"}
				label={(d) => $variableLabels[d.id]}
				formatValue={(v) => `${frmtF(v)} ${$inOutSectionsById.incoming.unit}`}
			/>
		</Html>
	</LayerCake>
</div>
<div class="middle">
	<GasStorage
		filled={gasStorageFilled}
		max={gasStorageMax}
		color="#737373"
		{barWidth}
		month={gasStorageMonth}
		valueColor={gasStorageValueColor}
	/>
</div>
<div class="last" style:border-color={$colors.outgoing.main}>
	<LayerCake
		y={yKey}
		x={yKey}
		{yDomain}
		ssr={true}
		percentRange={true}
		xDomain={yDomain}
		data={stackedDataOutgoing}
	>
		<Html>
			<Bar
				{barWidth}
				title={$inOutSectionsById.outgoing.title}
				subtitle={$inOutSectionsById.outgoing.subtitle}
				color={(d) => $colors.outgoing[d.id]}
				direction={"outgoing"}
				label={(d) => $variableLabels[d.id]}
				formatValue={(v) => `${frmtF(v)} ${$inOutSectionsById.outgoing.unit}`}
			/>
		</Html>
	</LayerCake>
</div>

<style lang="scss">
	.first,
	.last {
		flex-grow: 2;
		background: #f5f5f5;
		height: 175px;
		padding: 7px 7px;
		border-top: 1px solid;
		box-sizing: border-box;
	}

	.middle {
		display: flex;
		height: 185px;
		flex-direction: column;
		max-width: 150px;
		width: 84px;
	}
</style>
